import React from 'react';
import { Box, Card, CardContent, Typography } from '@mui/material';
import { CHOOSE_AN_AUDIENCE_TYPE } from '../../content/index';
import { makeStyles } from '@material-ui/core/styles';
const useStyles = makeStyles((theme) => ({
  containerBorder: {
    margin: '2rem',
    border: '1px solid rgba(0, 0, 0, 0.12)',
    borderRadius: 8,
    boxShadow: '0 0 2px rgba(0, 0, 0, 0.2)',
    background: 'white',
  },
  container: {
    padding: theme.spacing(4),
  },
  header: {
    marginBottom: '1rem',
  },
  cardWrapper: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: theme.spacing(4),
  },
  card: {
    flex: '1 1 calc(33.33% - 24px)',
    maxWidth: 'calc(33.33% - 24px)',
    cursor: 'pointer',
    transition: '0.3s',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    '&:hover': {
      boxShadow: theme.shadows[6],
    },
    cursor: 'pointer',
    borderRadius: 20,
  },
  iconBox: {
    fontSize: 30,
    marginBottom: theme.spacing(1),
  },
}));

export const AudienceTypeSelector = ({ options }) => {
  const classes = useStyles();

  return (
    <div
      style={{
        height: 'calc(100vh - 36px)',
        background: 'rgb(240, 239, 241)',
        marginTop: '-32px',
        paddingTop: 32,
      }}
    >
      <div className={classes.containerBorder}>
        <Box className={classes.container}>
          <div className={classes.header}>
            <Typography variant="h5">{CHOOSE_AN_AUDIENCE_TYPE}</Typography>
          </div>
          <Box className={classes.cardWrapper}>
            {options.map((option, index) => (
              <Card
                key={index}
                className={classes.card}
                variant="outlined"
                onClick={() => option.onClick(option.id)}
              >
                <CardContent>
                  <Box display="flex" alignItems="center" gap={1.5} mb={1}>
                    {option.icon}
                    <Typography variant="subtitle1" fontWeight="bold">
                      {option.title}
                    </Typography>
                  </Box>
                  <Typography
                    variant="body2"
                    color="text.secondary"
                    style={{ marginLeft: 36 }}
                  >
                    {option.description}
                  </Typography>
                </CardContent>
              </Card>
            ))}
          </Box>
        </Box>
      </div>
    </div>
  );
};
